module.exports = __webpack_public_path__ + "static/media/day15.workshop.496e7cc3.md";